import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './provider/UserProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GenProvider } from './provider/genProvider';
import { FilterProvider } from './provider/filterProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="915818391135-3i005ldonn55f3imm6h4b0r9k4cre71i.apps.googleusercontent.com">
    <Router>
      <UserProvider>
        <GenProvider>
          <FilterProvider>
            <App />
          </FilterProvider>
        </GenProvider>
      </UserProvider>
    </Router>
  </GoogleOAuthProvider >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
